import type { ManualPayments } from '@repo/utils';

export const MANUAL_PAYMENTS_EVENTS = {
    modalClose: 'salja:manual-payments:modal-close',
    navigateBack: 'salja:manual-payments:navigate-back',
    paymentFailure: 'salja:manual-payments:payment-failure',
    paymentSuccess: 'salja:manual-payments:payment-success',
} as const;

export const hasManualPaymentsFragment = (fragment: ManualPayments | undefined): fragment is Required<ManualPayments> =>
    typeof fragment?.getCanRegisterPayment === 'function' &&
    typeof fragment.openPaymentsHistory === 'function' &&
    typeof fragment.openRegisterPayment === 'function';
